import { create } from 'zustand';

interface initDataState {
  result: any;
  bind: (result: { data: any }) => void;
}

export const initDataStore = create<initDataState>(set => ({
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
}));
